<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Settings
      </h1>
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ name: 'dashboard' }">
            <i class="fa fa-dashboard"></i> Home
          </router-link>
        </li>
        <li class="active">
          Settings
        </li>
      </ol>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-info">
            <div class="box-header with-border">
              <h3 class="box-title">{{ title }}</h3>
            </div>

            <form class="form-horizontal" @submit.prevent="submit">
              <div class="box-body" style="overflow: unset;">
                <div v-if="error" class="alert alert-danger">
                  <a class="close" @click="error = false">
                    &times;
                  </a>
                  {{ error }}
                </div>

                <div class="form-group">
                  <label for="slug"
                    class="col-sm-2 control-label">
                    Meta Title <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="meta-title"
                      placeholder="Meta Title"
                      v-model="form.metaTitle">
                  </div>
                </div>

                <div class="form-group">
                  <label for="slug"
                    class="col-sm-2 control-label">
                    Meta Description <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="meta-description"
                      placeholder="Meta description"
                      v-model="form.metaDescription">
                  </div>
                </div>

                <div class="form-group">
                  <label for="name"
                    class="col-sm-2 control-label">
                    Hero Title <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="hero-title"
                      placeholder="Hero Title"
                      v-model="form.heroTitle">
                  </div>
                </div>

                <div class="form-group">
                  <label for="name"
                    class="col-sm-2 control-label">
                    Hero Title En <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input
                      type="text"
                      class="form-control"
                      id="hero-title_en"
                      placeholder="Hero Title"
                      v-model="form.heroTitle_en">
                  </div>
                </div>

                <div class="form-group">
                  <label for="parent"
                    class="col-sm-2 control-label">
                    Hero Background <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <div class="row">
                      <div class="col-md-2">
                        <img v-if="form.image.url"
                          class="img-thumbnail img-responsive"
                          alt="Destination Image"
                          :src="parseImage(form.image.url, '_thumb')">

                        <img v-else
                          class="img-thumbnail img-responsive"
                          src="/static/img/img_placeholder.png"
                          alt="No image">
                      </div>

                      <div class="col-md-10">
                        <button class="btn btn-sm btn-secondary"
                          @click.prevent="showModal('gallery')">
                          Select Image
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <transition name="slideDown">
                  <modal title="Select Background Image"
                    v-if="show.gallery">
                    <FileGallery
                      type="category"
                      @update-images="setImage"
                      :selected="form.image" />
                  </modal>
                </transition>
              </div>

              <div class="box-footer">
                <button type="submit" class="btn btn-info pull-right">Update</button>
                <a class="btn btn-default" @click.prevent="cancel">Cancel</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import Common from '@/mixins/Common';
import Modal from '@/components/modules/common/Modal';
import FileGallery from '@/components/modules/common/FileGallery';

export default {
  name: 'Settings',

  mixins: [Common],

  data() {
    return {
      title: 'Settings',

      form: {
        heroTitle: null,
        heroTitle_en: null,
        metaTitle: null,
        metaDescription: null,
        image: {
          id: null,
          url: null,
        },
      },

      show: {
        gallery: false,
      },

      error: null,
    };
  },

  components: {
    FileGallery,
    Modal,
  },

  methods: {
    fetch() {
      this.axios.get('/settings')
        .then((response) => {
          const { data } = response.data;

          data.forEach((item) => {
            if (item.slug === 'meta-title') {
              this.form.metaTitle = item.value;
            }

            if (item.slug === 'meta-description') {
              this.form.metaDescription = item.value;
            }

            if (item.slug === 'title') {
              this.form.heroTitle = item.value;
            }

            if (item.slug === 'title_en') {
              this.form.heroTitle_en = item.value;
            }

            if (item.slug === 'background') {
              this.form.image.url = item.value;
            }
          });
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data.errors;
          }
        });
    },

    showModal(modal) {
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      document.body.classList.add('locked');
    },

    setImage(payload) {
      this.form.image = payload.images;
    },

    validate() {
      if (!this.form.heroTitle) {
        this.$swal('Hero Title required', 'Please fill Hero Title to continue', 'warning');
        return false;
      }

      if (!this.form.heroTitle_en) {
        this.$swal('Hero Title En required', 'Please fill Hero Title En to continue', 'warning');
        return false;
      }

      if (!this.form.metaTitle) {
        this.$swal('Meta Title required', 'Please fill Meta Title to continue', 'warning');
        return false;
      }

      if (!this.form.metaDescription) {
        this.$swal('Meta Description required', 'Please fill Meta Description to continue', 'warning');
        return false;
      }

      if (!this.form.image) {
        this.$swal('Image required', 'Please select image to continue', 'warning');
        return false;
      }

      return true;
    },

    submit() {
      const result = this.validate();
      if (!result) return;

      const settings = [
        {
          slug: 'title',
          value: this.form.heroTitle,
        },
        {
          slug: 'title_en',
          value: this.form.heroTitle_en,
        },
        {
          slug: 'meta-title',
          value: this.form.metaTitle,
        },
        {
          slug: 'meta-description',
          value: this.form.metaDescription,
        },
        {
          slug: 'background',
          value: this.form.image.url,
        },
      ];

      const datas = {
        data: JSON.stringify(settings),
      };

      this.axios.put('/settings', this.stringify(datas))
        .then(() => {
          this.fetch();
          this.$swal('Updated', 'Setting updated', 'success');
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data.errors;
          }
        });
    },

    cancel() {
      this.$router.push('/');
    },
  },

  created() {
    this.fetch();
  },

  mounted() {
    bus.$on('close-modal', () => {
      this.show.gallery = false;
    });
  },

  destroyed() {
    bus.$off('close-modal');
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/settings/Index.vue